import React from 'react'
import BrandSlider from "components/BrandSlider";
import { Images } from 'constants';

const percentageData = [
    { company: 10, user: 90, showTwoSliders: true },
    { company: 15, user: 85, showTwoSliders: true },
    { company: 20, user: 80, showTwoSliders: true },
    { company: 25, user: 75, showTwoSliders: false },
    { company: 30, user: 70, showTwoSliders: false },
    { company: 40, user: 60, showTwoSliders: false },
    { company: 50, user: 50, showTwoSliders: false }
];

const BrandSliderSection = ({ company, user, showTwoSliders, wplink }) => (
    <>
        <div className='mb-1 px-2 brand-slider-heading relative flex justify-between items-center'>
            <div>
                <p>Company's {company}% And Your {user}%</p>
            </div>
            <div>
                <a href={wplink}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ textDecoration: "none" }}
                >
                    <img src={Images.WHATSAPP} alt="" width={98} height={28} />
                </a>
            </div>
        </div>
        {showTwoSliders ? (
            <>
                {/* <BrandSlider share={company} /> */}
                <BrandSlider share={company} direction={true} />
            </>
        ) : (
            <BrandSlider share={company} />
        )}
        <div className='custom-hr relative'></div>
    </>
);

const OptimizedSlider = ({ wplink }) => (
    <>
        {percentageData.map((data, index) => (
            <BrandSliderSection
                key={index}
                company={data.company}
                user={data.user}
                showTwoSliders={data.showTwoSliders}
                wplink={wplink}
            />
        ))}
    </>
);

export default OptimizedSlider;
